import { STORAGE_KEY_LOGIN, STORAGE_KEY_TOKEN, COOKIE_KEY_LOCALE, TOKEN_EXPIRE_DATE } from '../config/consts';
import { setCookie, getCookie } from './cookie.service';

const CurrentUserService = {
    getToken() {
        return localStorage.getItem(STORAGE_KEY_TOKEN);
    },

    setToken(value) {
        localStorage.setItem(STORAGE_KEY_TOKEN, value);
    },
    getLogin() {
        return localStorage.getItem(STORAGE_KEY_LOGIN);
    },

    setLogin(value) {
        localStorage.setItem(STORAGE_KEY_LOGIN, value);
    },

    getTokenExpirationDate() {
        return localStorage.getItem(TOKEN_EXPIRE_DATE);
    },

    setTokenExpirationDate(value) {
        return localStorage.setItem(TOKEN_EXPIRE_DATE, value);
    }
};

const LocaleService = {
    locales: {
        kz: 'kk-KZ',
        ru: 'ru-RU'
    },
    setLocale(locale) {
        setCookie(COOKIE_KEY_LOCALE, this.locales[locale], 30);
    },
    getLocale() {
        let locale = getCookie(COOKIE_KEY_LOCALE);
        if (locale) {
            for (let i in this.locales) {
                if (locale === this.locales[i]) {
                    return i;
                }
            }
        }
        return null;
    }
};

export { CurrentUserService, LocaleService };
